export const REDUCER_NAME = 'detail'




// WEBPACK FOOTER //
// ./src/modules/sales-order/state/detail/const.js